import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Graph from './graphTable';
import Bar from './bar';
import Message from '../common/message';
import utilFunction from '../../containers/function';

const validateDate = (filter, date) => {
  let dateValue;
  if (filter) {
    dateValue = filter;
  } else if (date) {
    dateValue = date.substring(0, 10);
  } else {
    dateValue = new Date();
  }
  return dateValue;
};

// function created for severity
const colorSeverityItem = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return 'gris';
  } else if (severety.toUpperCase() === 'HIGHRISK') {
    return 'red';
  } else if (severety.toUpperCase() === 'OUTOFRISK') {
    return 'green';
  } 
  return 'yellow';
};

const Table = props => (
  <div className="module-table top">
    <table>
      <thead>
        <tr>
          <th className="th150 left">
            <a className="noLink helpsortth">
              {props.language.filter[props.main.toLowerCase()]}{' '}
              <div className="modal-indicators-info">
                <a>
                  <i className="fas fa-question-circle" />
                  <div>
                    <p>{props.language.summary.behaviour.categoryHelp}</p>
                  </div>
                </a>
              </div>
            </a>
          </th>
          <th className="th100 right">
            <a className="noLink helpsortth">
              {props.language.summary.behaviour.driverNumber}
              <div className="modal-indicators-info">
                <a>
                  <i className="fas fa-question-circle" />
                  <div>
                    <p>{props.language.summary.behaviour.driverNumberHelp}</p>
                  </div>
                </a>
              </div>            
            </a>
          </th>
          <th className="th150 center">
            <a className="noLink helpsortth">
              {props.language.summary.behaviour.riskPeriod}
              <div className="modal-indicators-info">
                <a className="green">
                  <i className="fas fa-question-circle" />
                  <div>            
                    <p>
                      {props.language.summary.behaviour.indicatorHelp1Table
                        .replace(
                            "{category}",
                            props.language.filter[props.main.toLowerCase()]
                      )}
                    </p>
                    <p>{props.language.summary.behaviour.indicatorHelp2}</p>
                    <p>
                      <span className="green">
                      {props.language.summary.graphTooltip.OUTOFRISK + ": "}
                      </span> 
                      {props.language.summary.behaviour.between + " " + props.graphColorRange.outOfRisk[0] + " " + props.language.summary.behaviour.to + " 100"}
                    </p>
                    <p>
                      <span className="yellow">
                      {props.language.summary.graphTooltip.MIDDLERISK + ": "}
                      </span> 
                      {props.language.summary.behaviour.between + " " + (props.graphColorRange.middleRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + props.graphColorRange.middleRisk[1]}
                    </p>
                    <p>
                      <span className="red">
                      {props.language.summary.graphTooltip.HIGHRISK + ": "}
                      </span> 
                      {props.language.summary.behaviour.between + " " + (props.graphColorRange.higherRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + (props.graphColorRange.higherRisk[1])}
                    </p>
                  </div>
                </a>
              </div>
            </a>
          </th>
          <th className="center">
            <a className="noLink helpsortth">
              {props.language.summary.behaviour.driversAtRisk}
              <div className="modal-indicators-info">
                  <a className="green">
                    <i className="fas fa-question-circle" />
                    <div>            
                      <p>{props.language.summary.behaviour.evHelp1}</p>
                      <p>{props.language.summary.behaviour.evHelp2.replace("dd-mm-yyyy",
                          (utilFunction.getFormatFunction(
                            {type:"PARSE_DATE_STRING",format:["%d-%m-%Y","%Y-%m-%d"]}
                          ))(validateDate(props.filters.date.fechaEndFinal, props.date.response.maxDate))
                        )}
                      </p>
                      <p>
                        <span className="green">
                        {props.language.summary.graphTooltip.OUTOFRISK + ": "}
                        </span> 
                        {props.language.summary.behaviour.between + " " + props.graphColorRange.outOfRisk[0] + " " + props.language.summary.behaviour.to + " 100"}
                      </p>
                      <p>
                        <span className="yellow">
                        {props.language.summary.graphTooltip.MIDDLERISK + ": "}
                        </span> 
                        {props.language.summary.behaviour.between + " " + (props.graphColorRange.middleRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + props.graphColorRange.middleRisk[1]}
                      </p>
                      <p>
                        <span className="red">
                        {props.language.summary.graphTooltip.HIGHRISK + ": "}
                        </span> 
                        {props.language.summary.behaviour.between + " " + (props.graphColorRange.higherRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + (props.graphColorRange.higherRisk[1])}
                      </p>
                    </div>
                  </a>
                </div>            
            </a>
          </th>
          <th className="center">
            <a className="noLink helpsortth">
              {props.language.summary.behaviour.riskDistribution}
              <div className="modal-indicators-info left">
                <a className="green">
                  <i className="fas fa-question-circle" />
                  <div>            
                    <p>{props.language.summary.behaviour.distHelp1}</p>
                    <p>{props.language.summary.behaviour.distHelp2}</p>
                    <p>
                      <span className="green">
                      {props.language.summary.graphTooltip.OUTOFRISK + ": "}
                      </span> 
                      {props.language.summary.behaviour.between + " " + props.graphColorRange.outOfRisk[0] + " " + props.language.summary.behaviour.to + " 100"}
                    </p>
                    <p>
                      <span className="yellow">
                      {props.language.summary.graphTooltip.MIDDLERISK + ": "}
                      </span> 
                      {props.language.summary.behaviour.between + " " + (props.graphColorRange.middleRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + props.graphColorRange.middleRisk[1]}
                    </p>
                    <p>
                      <span className="red">
                      {props.language.summary.graphTooltip.HIGHRISK + ": "}
                      </span> 
                      {props.language.summary.behaviour.between + " " + (props.graphColorRange.higherRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + (props.graphColorRange.higherRisk[1])}
                    </p>
                  </div>
                </a>
              </div>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        {props.datos.map((item, i) => {
          return item.driversCount==null ? (
            <tr
              key={`${i}`}
              data-datos={JSON.stringify(item)}
              className="hover click"
              onClick={props.link}
            >
              {/* Name */}
              <td className="first">
                <div className="td-alias">
                  <span className={`${colorSeverityItem(item.severity)} font16`} />
                  <div>{item.tag}</div>
                </div>
              </td>
              <td className="center" colSpan={4}>
                <p className="red center">{props.language.summary.behaviour.noDataAvailable}</p>
              </td>
            </tr>
          ) : (
            <tr
              key={`${i}`}
              data-datos={JSON.stringify(item)}
              className="hover click"
              onClick={props.link}
            >
              {/* Name */}
              <td className="first">
                <div className="td-alias">
                  <span className={`${colorSeverityItem(item.severity)} font16`} />
                  <div>{item.tag}</div>
                </div>
              </td>
              <td className="right">{item.driversCount}</td>
              {/* Average Risk */}
              <td className="center td-avg">
                <div className="avg">
                  {
                    <span className={colorSeverityItem(item.severity) + " bigIndicator"}>
                      {item.behaviorGrade!=null ? item.behaviorGrade : ""}
                    </span>
                  }
                </div>
              </td>
              <td className="center">
                <div className="flex align-center">
                  <div className="graph-table">
                    <Graph
                      tooltip={props.language}
                      graphColorRange={props.graphColorRange}
                      data={item.dailyBehaviorGradeList}
                      id={`graph-${i}`}
                      period={item.period}
                    />
                  </div>
                  <div className="graph-table-indicator">
                    {item.dailyBehaviorGradeList.length > 0 ? (
                      <p
                        className={colorSeverityItem(
                          item.dailyBehaviorGradeList[item.dailyBehaviorGradeList.length - 1].severity
                        )}
                      >
                        {' '}
                        {item.dailyBehaviorGradeList[item.dailyBehaviorGradeList.length - 1].behaviorGrade!=null ? 
                          item.dailyBehaviorGradeList[item.dailyBehaviorGradeList.length - 1].behaviorGrade :
                          ""
                        }
                      </p>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </td>
              <td className="center">
                <Bar 
                  distribution={item.distribution} 
                  language={props.language}
                />
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  </div>
);

Table.propTypes = {
  language: PropTypes.oneOfType([PropTypes.object]).isRequired,
  datos: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ]).isRequired
};

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/summary_behaviour/table.jsx